import React, { useMemo } from 'react';
import { Select } from 'components/Form';
import { useT } from 'hooks/Locale/useT';
import { useLocaleContext } from 'context/LocaleContext';
import useQueryApiClient from 'utils/useApiClient';

interface Language {
    code: string;
    name: string;
    publish: boolean;
}

interface LanguageSelectProps {
    name: string;
    label: string;
    published?: boolean;
    disabled?: boolean;
    [prop: string]: unknown;
}

const LanguageSelect: React.FC<LanguageSelectProps> = ({
    name,
    label,
    published = true,
    disabled = false,
    ...props
}) => {
    const t = useT();
    const { locale } = useLocaleContext();
    const { data, isLoading } = useQueryApiClient({ request: { url: '/api/v1/language' } });

    const options = useMemo(() => {
        const result: Record<string, string> = {};
        Object.values<Language>(data?.languages ?? {})
            .filter((language) => !published || language.publish)
            .forEach((language) => {
                result[language.code] = t(
                    `system.languages.${language.code.toLowerCase()}`,
                    language.name,
                );
            });
        return result;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data, published, locale]);

    return (
        <Select
            name={name}
            label={label}
            loading={isLoading}
            manualOptions={options}
            customRules={[{ required: true, message: t('validation.field_required') }]}
            disabled={disabled}
            {...props}
        />
    );
};

export default LanguageSelect;
